<template>
	<v-row dense class="pb-3">
		<v-col cols="12">
			<BankIDLogin @isAuthenticating="(value) => isAuthenticatingWithBankID = value" :disabled="isRedirectingToFreja"/>
		</v-col>

		<v-col v-if="showButtonFreja" cols="12" v-show="!isAuthenticatingWithBankID">
			<v-card-text class="pt-0 pb-0">
				<v-row dense>
					<v-col cols="12">

						<v-btn
							color="primary"
							width="100%"
							large
							style="text-transform: none;"
							@click="onFreja"
							:disabled="isAuthenticatingWithBankID"
							:loading="isRedirectingToFreja"
							depressed
						>
							<img
								:src="require('@/assets/img/FrejaSmallTransparentWhite.png')"
								height="35"
								width="35"
								style="margin-left: -8px; margin-right: 8px;"
							/>
							{{$t('Freja.AuthBtnText')}}
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-col>
	</v-row>
</template>

<script>
import LocalStorage from '../../../lib/LocalStorage.js';
import BankIDLogin  from './BankIDLogin.vue';

export default {
	name: 'ElectronicIDLogin',

	data: () => ({
		isAuthenticatingWithBankID: false,
		isRedirectingToFreja:       false,
	}),

	methods: {
		onFreja() {
			LocalStorage.set('LoginMethod', 0);
			this.isRedirectingToFreja = true;
			try {
				window.location.href = this.$buildURL('/oidc/authorize/frejaeid', {apiRoute: true});
			} finally {
				this.isRedirectingToFreja = false;
			}
		},
	},

	computed: {
		showButtonFreja() {
			return this.isWebApp || window.MobileApp.Info.hasFeatureFrejaeid;
		},
	},

	components: {BankIDLogin},
}
</script>

<style scoped>

</style>
